import { Outlet } from 'react-router-dom';
import { FC } from 'react';

const CommonLayout: FC = () => (
	<>
		<Outlet />
	</>
);

export default CommonLayout;
